import styled, { css } from 'styled-components';

// CONSTANTS
import { theme } from '../../constants/theme';

// INTERFACES
import { IContent } from '../../interfaces/Content.interface';

export const ContentStyled = styled.div<IContent>`
  display: block;
  width: 1005px;
  max-width: 100%;
  margin-top: 153px;
  padding-left: 40px;

  ${({ otherwidth }) =>
    otherwidth &&
    css`
      width: 1253px;
      max-widht: auto;
    `}

  ${({ isWhite }) =>
    isWhite &&
    css`
      background: ${theme.colors.primary.white};
      margin-top: 81px;
      padding-top: 73px;
      max-height: calc(100vh - 87px);
      min-height: calc(100vh - 87px);
      width: 100%;
      overflow-y: scroll;
    `}

  ${({ innerPage }) =>
    innerPage &&
    css`
      padding-left: 0;
      padding-top: 0;
    `}
`;
